import { theme } from 'themes/default';

export const categories: Record<string, Record<string, string>> = {
  dtp: {
    bg: theme.palette.common.white,
    color: theme.palette.custom.primary.grey[150],
    numColor: theme.palette.custom.primary.grey[150],
  },
  isp: {
    bg: theme.palette.custom.secondary.blue[120],
    color: theme.palette.common.white,
    numColor: theme.palette.custom.secondary.blue[120],
  },
  dap: {
    bg: theme.palette.custom.secondary.blue[80],
    color: theme.palette.common.white,
    numColor: theme.palette.custom.secondary.blue[120],
  },
  cpa: {
    bg: theme.palette.custom.secondary.blue[80],
    color: theme.palette.common.white,
    numColor: theme.palette.custom.secondary.blue[120],
  },
  mpr: {
    bg: theme.palette.custom.secondary.green[100],
    color: theme.palette.common.white,
    numColor: theme.palette.custom.secondary.green[120],
  },
  dfp: {
    bg: theme.palette.custom.secondary.green[100],
    color: theme.palette.common.white,
    numColor: theme.palette.custom.secondary.green[120],
  },
  irrmf: {
    bg: theme.palette.custom.primary.grey[100],
    color: theme.palette.common.white,
    numColor: theme.palette.custom.primary.grey[150],
  },
};
